import { render, staticRenderFns } from "./CMainSlideShapePc.vue?vue&type=template&id=cbb6a05c&"
import script from "./CMainSlideShapePc.vue?vue&type=script&lang=js&"
export * from "./CMainSlideShapePc.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CMainSlideShapePc.vue?vue&type=style&index=0&id=cbb6a05c&prod&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports